import React from "react";
import { Link } from "react-router-dom";

const ParkingMap = () => {
  return (
    <>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link
        href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css"
        rel="stylesheet"
        integrity="sha384-T3c6CoIi6uLrA9TneNEoa7RxnatzjcDSCmG1MXxSR1GAsXEV/Dwwykc2MPK8M2HN"
        crossOrigin="anonymous"
      />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
      <link
        href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap"
        rel="stylesheet"
      ></link>
      <div
        className="content"
        style={{ display: "flex", flexDirection: "column" }}
      >
        <div className="parking-map">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 2400 1600" // Dopasuj ten widok do wymiarów zdjęcia
            className="svg-overlay"
          >
            <image href="https://webosta.net/wp-content/uploads/2024/11/DJI_0483-1-scaled.jpg" />

            <polygon
              points="1297,723 975,700 955,990 1275,1020"
              className="parking-area-slam"
            />
            <text
              x="1125.5" // Współrzędne centroidu
              y="935.25"
              textAnchor="middle"
              alignmentBaseline="middle"
              className="svg-text"
              fontSize="52"
              transform="rotate(4, 1975.6, 935.25)" // Obrót o 10 stopni wokół punktu (1427.5, 1162)
            >
              <tspan x="1125.5" dy="0">
                SLAM DE
              </tspan>{" "}
            </text>
            {/* Parking #1 */}
            <Link to="/super-admin/parking-1">
              <polygon
                points="1865,391 2267,400 1986,1118 1792,1115 1831,737"
                className="parking-area"
              />

              <text
                x="1975.6" // Współrzędne centroidu
                y="723.6"
                textAnchor="middle"
                alignmentBaseline="middle"
                className="svg-text"
                fontSize="36"
                transform="rotate(4, 1975.6, 723.6)" // Obrót o 10 stopni wokół punktu (1427.5, 1162)
              >
                <tspan x="1975.6" dy="0">
                  PARKING #1
                </tspan>{" "}
                {/* Pierwsza linia */}
                <tspan x="1975.6" dy="40">
                  220 slots
                </tspan>{" "}
                {/* Druga linia */}
              </text>
            </Link>

            {/* Parking #2 */}
            <Link to="/super-admin/parking-2">
              <polygon
                points="1209,305 1851,393 1822,543 1193,436 1200,384"
                className="parking-area"
              />
              <text
                x="1500" // Współrzędne centroidu
                y="412.2"
                textAnchor="middle"
                alignmentBaseline="middle"
                className="svg-text"
                fontSize="36"
                transform="rotate(4, 1500, 640)" // Obrót o 10 stopni wokół punktu (1427.5, 1162)
              >
                <tspan x="1500" dy="0">
                  PARKING #2
                </tspan>{" "}
                {/* Pierwsza linia */}
                <tspan x="1500" dy="40">
                  90 slots
                </tspan>{" "}
                {/* Druga linia */}
              </text>
            </Link>
            <Link to="/super-admin/parking-3">
              <polygon
                points="1338,488 1799,577 1783,764 1369,755 1374,721 1320,715"
                className="parking-area"
              />

              <text
                x="1550" // Współrzędne centroidu
                y="640"
                textAnchor="middle"
                alignmentBaseline="middle"
                className="svg-text"
                fontSize="36"
                transform="rotate(4, 1550, 640)" // Obrót o 10 stopni wokół punktu (1427.5, 1162)
              >
                <tspan x="1550" dy="0">
                  PARKING #3
                </tspan>{" "}
                {/* Pierwsza linia */}
                <tspan x="1550" dy="40">
                  100 slots
                </tspan>{" "}
                {/* Druga linia */}
              </text>
            </Link>

            {/* Parking #4 */}
            <Link to="/super-admin/parking-4">
              <polygon
                points="1770,1045 1349,1011 1367,769 1783,796"
                className="parking-area"
              />
              <text
                x="1570" // Współrzędne obliczone na podstawie centroidu
                y="900"
                textAnchor="middle"
                alignmentBaseline="middle"
                className="svg-text"
                fontSize="36"
                transform="rotate(4, 1570, 900)" // Obrót o 10 stopni wokół punktu (1427.5, 1162)
              >
                <tspan x="1570" dy="0">
                  PARKING #4
                </tspan>{" "}
                {/* Pierwsza linia */}
                <tspan x="1570" dy="40">
                  100 slots
                </tspan>{" "}
                {/* Druga linia */}
              </text>
            </Link>

            {/* Parking #5 */}
            <Link to="/super-admin/parking-5">
              <polygon
                points="1541,1285 1557,1061 1313,1036 1299,1266"
                className="parking-area"
              />

              <text
                x="1427.5" // Współrzędne centroidu
                y="1152"
                textAnchor="middle"
                alignmentBaseline="middle"
                className="svg-text"
                fontSize="32"
                transform="rotate(4, 1427.5, 1162)" // Obrót o 10 stopni wokół punktu (1427.5, 1162)
              >
                <tspan x="1427.5" dy="0">
                  PARKING #5
                </tspan>{" "}
                {/* Pierwsza linia */}
                <tspan x="1427.5" dy="40">
                  50 slots
                </tspan>{" "}
                {/* Druga linia */}
              </text>
            </Link>

            {/* Parking #6 */}
            <Link to="/super-admin/parking-6">
              <polygon
                points="1392,1355 1381,1529 922,1513 931,1323"
                className="parking-area"
              />
              <text
                x="1176.5" // Współrzędne centroidu
                y="1430"
                textAnchor="middle"
                alignmentBaseline="middle"
                className="svg-text"
                fontSize="32"
                transform="rotate(4, 1176.5, 1162)" // Obrót o 10 stopni wokół punktu (1427.5, 1162)
              >
                <tspan x="1176.5" dy="0">
                  PARKING #6
                </tspan>{" "}
                {/* Pierwsza linia */}
                <tspan x="1176.5" dy="40">
                  100 slots
                </tspan>{" "}
                {/* Druga linia */}
              </text>
            </Link>
          </svg>
        </div>
      </div>
    </>
  );
};

export default ParkingMap;
